module.exports = __webpack_public_path__ + "img/hongbao.f189bc29.png";